import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';

function AddEditSection({ t, isEditable, openModal, pack }) {
  const { amountVariationsPerAdvancedPack } = pack || {};

  return (
    <div
      className="edit-advancedPack-section"
      style={{
        justifyContent: isEditable ? 'flex-end' : 'flex-start',
      }}
    >
      {!isEditable && (
        <button
          className="addBtn"
          type="button"
          onClick={event => {
            event.preventDefault(); // Prevents the <a> navigation
            event.stopPropagation();
            openModal('add');
          }}
        >
          <div className="plus">
            <i className="fa fa-plus" />
          </div>
          <span className="info">
            {t(
              'advancedPack.amountOfProducts',
              amountVariationsPerAdvancedPack,
            )}
          </span>
        </button>
      )}
      {isEditable && (
        <button
          className="editBtn"
          type="button"
          onClick={event => {
            event.preventDefault(); // Prevents the <a> navigation
            event.stopPropagation();
            openModal('edit');
          }}
        >
          <div className="edit">
            <i className="fa fa-pen" />
          </div>
          <span className="info">{t('advancedPack.edit')}</span>
        </button>
      )}
    </div>
  );
}

AddEditSection.propTypes = {
  t: PropTypes.func.isRequired,
  pack: PropTypes.shape({
    amountVariationsPerAdvancedPack: PropTypes.number.isRequired,
  }).isRequired,
  isEditable: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
};

AddEditSection.defaultProps = {
  isEditable: false,
};

export default translate(AddEditSection);
